export const removeAllEmptyCharacters = (str: string) => str.replace(/(\s|\t|\n)+/g, '')
